import ObjectTableController from "./object_table_controller"

export default class RequirementsObjectTableController extends ObjectTableController {
  static values = {
    ...ObjectTableController.values,
    listTypeFriendlyName: "requirement",
    subjectType: "requirement",
    fetchUrl: { type: String, default: "/companies/requirements" },
  }

  onItemClick({ data }) {
    window.Turbo.visit(data.link_to)
  }
}
